module.exports = __webpack_public_path__ + "media/images/signup-magnet-e51770c537ac51db7ab6158eec748628.svg";